define("shared/components/shared/social/refresh-profile/facebook/index", ["exports", "@ember/component", "@ember/debug", "@ember/service", "shared/components/shared/social/refresh-profile/abstract-refresh-profile-button", "@ember/template-factory"], function (_exports, _component, _debug, _service, _abstractRefreshProfileButton, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/debug",0,"@ember/service",0,"shared/components/shared/social/refresh-profile/abstract-refresh-profile-button",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Social::RefreshProfile::BaseButton
    @buttonVariant={{@buttonVariant}}
    @isLocked={{@isLocked}}
    @onProfileRefresh={{this.onProfileRefresh}}
    @severity={{@severity}}
    @socialProfile={{@socialProfile}}
    class={{if @buttonClass @buttonClass}}
  />
  */
  {
    "id": "SyDEvLcY",
    "block": "[[[8,[39,0],[[16,0,[52,[30,1],[30,1]]]],[[\"@buttonVariant\",\"@isLocked\",\"@onProfileRefresh\",\"@severity\",\"@socialProfile\"],[[30,2],[30,3],[30,0,[\"onProfileRefresh\"]],[30,4],[30,5]]],null]],[\"@buttonClass\",\"@buttonVariant\",\"@isLocked\",\"@severity\",\"@socialProfile\"],false,[\"shared/social/refresh-profile/base-button\",\"if\"]]",
    "moduleName": "shared/components/shared/social/refresh-profile/facebook/index.hbs",
    "isStrictMode": false
  });
  let RefreshProfileFacebookComponent = _exports.default = (_dec = (0, _service.inject)('social/facebook-auth'), (_class = class RefreshProfileFacebookComponent extends _abstractRefreshProfileButton.AbstractRefreshProfileButtonComponent {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "facebookAuth", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      if (!this.args.socialProfile) {
        (false && !(false) && (0, _debug.assert)('Argument `socialProfile` is required'));
      }
    }
    async handleRefresh() {
      const socialProfile = await this.args.socialProfile;
      try {
        const data = await this.facebookAuth.authenticate.perform({
          refreshSocialProfile: socialProfile
        });
        return {
          data
        };
      } catch (error) {
        // Note: We need to handle pre-defined errors from refreshFacebook similarly to 'error-overlay.ts'
        // to ensure users receive relevant information
        if (typeof error === 'string') {
          return {
            error: {
              message: error,
              title: this.intl.t('alerts.account.controllers.groups.facebook.refresh_error_title')
            }
          };
        }
        return {
          error
        };
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "facebookAuth", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, RefreshProfileFacebookComponent);
});